var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cm-blackbar"},[_c('div',{staticClass:"cm-blackbar__header"}),_c('div',{staticClass:"cm-blackbar__sideBar"}),_c('div',{staticClass:"cm-blackbar__body"},[_vm._t("default")],2),_c('div',{staticClass:"cm-blackbar__footer"})])
}
var staticRenderFns = []

export { render, staticRenderFns }